import React, { useEffect, useRef, useState } from 'react'
import CreatePurchases from '../CreatePurchases/CreatePurchases'
import Button from '../../components/Button'
import api from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import { isAxiosError } from 'axios'
import customMainApi from '../../api/index'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const CreatePurchasesPage = () => {
	const navigate = useNavigate()
	const successModalRef = useRef()
	const errorRef = useRef()
	const { t } = useTranslation()

	const [itemName, setItemName] = useState('')
	const [color, setColor] = useState('')
	const [memory, setMemory] = useState('')
	const [condition, setCondition] = useState('')
	const [btnLoading, setBtnLoading] = useState(false)
	const [userFields, setUserFields] = useState([])
	const [series, setSeries] = useState([])
	const [serie, setSerie] = useState('')
	const [group, setGroup] = useState('')

	const CreateItemsPost = async () => {
		setBtnLoading(true)

		try {
			await api
				.post(`Items`, {
					ItemName: itemName,
					Series: serie,
					ManageBatchNumbers: 'tNO',
					ManageSerialNumbers: 'tYES',
					CostAccountingMethod: 'bis_SNB',
					U_Color: color,
					U_Condition: condition,
					U_Memory: memory,
					U_Group: group,
				})
				.then((res) => {
					successModalRef.current?.open(t('sucUser'))
					return JSON.parse(res.data).value
				})
		} catch (e) {
			if (isAxiosError(e)) {
				errorRef.current?.open(
					get(JSON.parse(e.response.data), 'error.message', ''),
				)
			}
		} finally {
			setBtnLoading(false)
		}
	}

	const getItemSeries = () => {
		api
			.post('SeriesService_GetDocumentSeries', {
				DocumentTypeParams: {
					Document: '4',
				},
			})
			.then((res) => {
				const items = JSON.parse(res.data).value
				const filteredItems = items.filter((item) => item.IsManual === 'tNO')
				setSeries(filteredItems)
			})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM' ",
				},
				headers: {
					Prefer: 'odata.maxpagesize=2000',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const handlePostBtnClick = () => {
		CreateItemsPost()
	}

	useEffect(() => {
		userFieldsFn()
		getItemSeries()
	}, [])

	return (
		<Layout>
			<CreatePurchases>
				<div className="container minWidthContainer">
					<div className="overflow-y-auto my-8">
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 "></thead>
							<tbody>
								<tr className="bg-white  hover:bg-gray-50 ">
									<td className="px-6 py-4 border">
										<div className="searchable-select">
											<div className={'searchableHead'}>
												<div>
													<p>{t('productName')}</p>
													<input
														className={
															'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[300px]'
														}
														type="text"
														onChange={(e) => {
															setItemName(e.target.value)
														}}
														placeholder={t('productName')}
														value={itemName}
													/>
												</div>
											</div>
										</div>
									</td>
									<td className="px-6 border py-4">
										<p className="flex items-center gap-1">
											{t('uGroup')}
											<span className="text-red-600 text-xl">*</span>
										</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[130px]'
											}
											onChange={(event) => setGroup(event.target.value)}
											value={group}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Group')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>{t('serie')}</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[100px]'
											}
											onChange={(e) => {
												setSerie(e.target.value)
											}}
											value={serie}
										>
											<option key={''} value={''}></option>
											{series.map((item, idx) => (
												<option key={idx} value={item.Series}>
													{item.Prefix}
												</option>
											))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>{t('condition')}</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[100px]'
											}
											onChange={(event) => {
												setCondition(event.target.value)
											}}
											value={condition}
										>
											<option value=""></option>
											<option value="NEW"> NEW</option>
											<option value="B/U"> B/U</option>
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>{t('color')}</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[150px]'
											}
											onChange={(event) => setColor(event.target.value)}
											value={color}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Color')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>{t('memory')}</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[100px]'
											}
											onChange={(event) => setMemory(event.target.value)}
											value={memory}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Memory')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div
						style={{
							display: 'flex',
							justifyContent: 'end',
							paddingRight: '50px',
							paddingTop: '30px',
						}}
					>
						<Button
							isLoading={btnLoading}
							onClick={handlePostBtnClick}
							disabled={!group}
						>
							{t('create')}
						</Button>
					</div>
				</div>
			</CreatePurchases>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						successModalRef.current = r
					}}
					onConfirm={() => navigate('/purchases')}
				/>
			</>
		</Layout>
	)
}

export default CreatePurchasesPage
